import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Support from "./pages/Support";
import DeleteAccount from "./pages/DeleteAccount";
import ShareImage from "./pages/ShareImage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Bootstrap from "./components/Bootstrap";
import RequireAdmin from "./components/RequireAdmin";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes Bootstrap */}
        <Route element={<Bootstrap />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Route>
        
        {/* Standalone Share Route (without navbar/footer) */}
        <Route path="/share" element={<ShareImage />} />

        {/* Standalone Admin Routes (internal tool, no public nav/footer) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
